module.exports = __webpack_public_path__ + "adb32e6cb9fa3b640c94cc66b3127c26.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/bonnier.svg
// module id = 170
// module chunks = 0